import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 1rem;
`;
export { Wrapper };
